export function srEq(a,b){
  const na=Number(a), nb=Number(b);
  if(!Number.isFinite(na)||!Number.isFinite(nb)) return String(a)===String(b);
  return Math.abs(na-nb)<=5;
}

export function freqEq(a,b){
  const na=Number(a), nb=Number(b);
  if(!Number.isFinite(na)||!Number.isFinite(nb)) return String(a)===String(b);
  return Math.abs(na-nb)<=2;
}